import React, { useState } from "react";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { animated, useSpring } from "react-spring";
import { springConfigs } from "../../constants/springConfigs";
import { CircularButtonBorder } from "./CircularButton";

export const CircularButtonMenu = ({
  animatedOffset,
  color,
  left,
  onClick,
  containerStyle,
}: {
  animatedOffset: any;
  color: string;
  left: boolean;
  onClick: Function;
  containerStyle?: React.CSSProperties;
}) => {
  const [hover, hoverSet] = useState(false);
  const { padding } = useSpring({
    from: { padding: "120%" },
    to: { padding: "0%" },
    config: springConfigs.outlineAppear,
  });

  const { marginLeft } = useSpring({
    from: { marginLeft: hover ? "0px" : "0px" },
    to: { marginLeft: hover ? (left ? "-4px" : "4px") : "0px" },
  });

  return (
    <animated.div
      style={{
        cursor: "pointer",
        display: "grid",
        gridTemplate: `
        "center"
        `,
        overflow: "hidden",
        justifyContent: "center",
        alignItems: "center",
        ...containerStyle,
      }}
      onClick={() => onClick(left)}
      onMouseEnter={() => {
        hoverSet(true);
      }}
      onMouseLeave={() => {
        hoverSet(false);
      }}
    >
      {/*  border */}
      <CircularButtonBorder {...{ animatedOffset, color, left }} />
      {/* animated arrow */}
      {left && (
        <animated.div
          style={{
            paddingLeft: padding, // appear
            marginLeft,
            gridArea: "center",
            placeSelf: "center",
            fontSize: "1.125rem",
            lineHeight: "1.75rem",
            justifyContent: "center",
          }}
        >
          <BiChevronLeft />
        </animated.div>
      )}
      {!left && (
        <animated.div
          style={{
            paddingRight: padding, // appear
            marginLeft,
            gridArea: "center",
            placeSelf: "center",
            fontSize: "1.125rem",
            lineHeight: "1.75rem",
          }}
        >
          <BiChevronRight />
        </animated.div>
      )}
    </animated.div>
  );
};
